<template>
  <Dialog :open="isOpen" @update:open="(value) => emit('update:isOpen', value)">
    <DialogContent class="sm:max-w-[425px]">
      <DialogHeader>
        <DialogTitle>Change Bubble Title</DialogTitle>
        <DialogDescription> Enter a new title for this bubble. </DialogDescription>
      </DialogHeader>
      <form @submit.prevent="handleSubmit">
        <div class="grid gap-4 py-4">
          <div class="grid grid-cols-4 items-center gap-4">
            <Label for="name" class="text-right"> New Title </Label>
            <Input id="name" v-model="newTitle" placeholder="Enter new title" class="col-span-3" />
          </div>
        </div>
        <DialogFooter class="mt-4">
          <Button type="button" variant="outline" @click="closePopup">Cancel</Button>
          <Button type="submit">Save</Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

const props = defineProps<{
  isOpen: boolean
  bubbleUuid: string
  currentTitle: string
}>()

const emit = defineEmits(['update:isOpen', 'titleChanged'])

const newTitle = ref(props.currentTitle)

const closePopup = () => {
  emit('update:isOpen', false)
}

const handleSubmit = () => {
  emit('titleChanged', newTitle.value)
  closePopup()
}
</script>
